import { useGetRelatedProducts } from '@/shared/lib/hooks/useGetRelatedProducts'

/**
 Generates link to the fast order page
 @function
 @name useFastOrderLink
 @param {number} mainProductID - The ID of the main product.
 @param {OrderFormsDefaultValues} defaultOrderValues
 @returns {Array.<string>} - An array of product ids.
 */
export const useFastOrderLink = (mainProductID: number, defaultOrderValues?: any, orderSource?: string): string => {
	const relatedItems = useGetRelatedProducts(mainProductID)
	const addonsIDs = relatedItems.map(({ ID }) => ID)

	let resultUrl = `/order/${[...addonsIDs, mainProductID].join(`,`)}/`
	const queryParts: string[] = []

	if (defaultOrderValues && Object.values(defaultOrderValues).length) {
		queryParts.push(`defaultOrderValues=${JSON.stringify(defaultOrderValues)}`)
	}

	if (orderSource) {
		queryParts.push(`source=${orderSource}`)
	}

	const queryString = queryParts.join('&')
	if (queryString) {
		resultUrl += `?${queryString}`
	}

	return resultUrl
}
